// extracted by mini-css-extract-plugin
export default {"projects_list":"projects-list_projects_list__n2zRk","project-legend":"projects-list_project-legend__bYI87"};